export default {
  app: {
    name: "Paralympic",
    subtitle: "Canada Connect",
    logo: null,
    icon: require("../assets/npc_logo.png"),
    multiLang: false,
    // defaultPage: '/dashboard-v2', // experimental dashboard ,
    // defaultPage: '/dashboard', // default home page ,
    defaultPage: "/about-npc-canada", // default home page ,
    //defaultPage: '/contacts',
    state: "loading",
    baseUrl:
      process.env.NODE_ENV === "production"
        ? // ? '/npc-connect/' // product build base url
          "/npc-connect/"
        : "/npc-connect/",
    requiresAuth: false, // if set true user must be logged in to see ANY part of app
    user: {
      FullName: "",
      FirstName: "",
      LastName: "",
      Email: "",
      role: "user",
      lang: "en",
      loggedIn: false,
      profile_uid: null,
      uid: null,
    },
  },
  userDefault: {
    FullName: "",
    FirstName: "",
    LastName: "",
    Email: "",
    role: "user",
    lang: "en",
    loggedIn: false,
    profile_uid: null,
    uid: null,
  },
  production: {
    url: "./",
  },
  notification: {
    default: {
      snackbar: true,
      text: "My timeout is set to 2000.",
      timeout: 2000,
      color: "",
      mode: "",
      centered: false,
      x: null,
      y: "top",
    },
  },
  debug: false,
  i18n: false,
  images: [
    { name: "full", height: "1200px", width: "1200px" },
    { name: "medium", height: "800px", width: "800px" },
    { name: "small", height: "400px", width: "400px" },
    { name: "thumbnail", height: "150px", width: "150px" },
  ],
};